<script setup lang="ts">
/**
 * Error page for `ErrorCode.KeycloakUnavailable` (effective HTTP 503).
 *
 * Shown when the periodic Keycloak health check reports the IdP as down and
 * `redirectToLogin()` routes to this page instead of starting the OAuth flow
 * (to avoid a broken redirect to an unavailable IdP). Title, explanation, and
 * actions come from `ERROR_USER_MESSAGES`. Shows a "Go To Login" button so
 * the user can retry once Keycloak recovers.
 */
import ErrorView from '@/components/errors/ErrorView.vue'
import { ErrorCode } from '@/errors/codes'
import { ERROR_USER_MESSAGES } from '@/errors/error_user_messages'
import { redirectToLogin } from '@/api/keycloak_api'

const page = ERROR_USER_MESSAGES[ErrorCode.KeycloakUnavailable]
const title = page.title
const explanation = page.explanation
const actions = page.actions ?? []

function goToLogin() {
  redirectToLogin()
}
</script>

<template>
  <ErrorView
    :code="ErrorCode.KeycloakUnavailable"
    :title="title"
    :explanation="explanation"
    :actions="actions"
  >
    <button class="tufte-button" @click="goToLogin">Go To Login</button>
  </ErrorView>
</template>
